import { ActionContext } from 'vuex';
import { IStoreState } from './State';

/**
 * @type ActionContext<S, R>
 */
type Context = ActionContext<IStoreState, IStoreState>;

/**
 * Actions are generally meant to be the entrypoint for modifying state.
 *
 * They are asynchronous calls that can perform other tasks and then
 * trigger a mutation (synchronous).
 *
 * @see https://vuex.vuejs.org/guide/actions.html
 *
 * @class Actions
 * @package Store/Module/UserGuidance
 * @project ChalkySticks SDK Vue2.0 Components
 */
const actions = {
	/**
	 * @param Context context
	 * @param any payload
	 * @return void
	 */
	example(context: Context, payload: any): void {
		context.commit('example', payload);
	},

	/**
	 * Mark a coach mark as seen
	 *
	 * @param Context context
	 * @param string coachMarkId
	 * @return void
	 */
	markCoachMarkSeen(context: Context, coachMarkId: string): void {
		console.log('marking', coachMarkId, context.state);

		if (!context.state.coachMarksSeen.includes(coachMarkId)) {
			const updatedCoachMarks = [...context.state.coachMarksSeen, coachMarkId];

			context.commit('setCoachMarksSeen', updatedCoachMarks);
		}
	},

	/**
	 * Legacy alias for markCoachMarkSeen (for backwards compatibility)
	 *
	 * @param Context context
	 * @param string tooltipId
	 * @return void
	 */
	markTooltipSeen(context: Context, tooltipId: string): void {
		actions.markCoachMarkSeen(context, tooltipId);
	},
};

export default actions;
